import styled from 'styled-components';
import { Collapse } from 'UI';

export const MainContainer = styled.div`
  display: flex;
  width: 100%;
  padding-top: 1.5rem;
`;

export const OrderItemsCollapse = styled(Collapse)`
  width: 100%;
`;
